/**
 * @param {T} target
 * @param {...U} sources
 * @return {T|U}
 * @template T, U
 */
function _assign(target, ...sources) {
  for (const s of sources) {
    /* eslint-disable-next-line guard-for-in, no-restricted-syntax */
    for (const k in s) {
      target[k] = s[k];
    }
  }

  return target;
}

export const assign = Object.assign || _assign;
